import React, { useEffect, useState } from "react";
import {
  Card,
  Grid,
  Tabs,
  Tab,
  Button,
  // Divider,
  Chip,
  // CardHeader,
  // CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Autocomplete,
  Stack,
  // StatusChip,
  useMediaQuery,
  useTheme,
  Snackbar,
  Alert
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ListAltIcon from "@mui/icons-material/ListAlt";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { endPoints } from "../../apis";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ImagePreview from "../../components/ImagePreview/ImagePreview";
import apiRequest from "../../apiRequest";
import { useNavigate } from "react-router-dom";
import CancelButton from "../../components/CancelButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PaginationControls from "../../components/PaginationControls/PaginationControls";
import PageLoader from "../../components/PageLoader/PageLoader";
import AppSnackbar from "../../components/AppSnackbar/AppSnackbar";
import { fetchPartnerById, fetchPartnerWalletTypes, fetchPartnerWallet, createOrUpdateWallet, fetchPartnerWalletTransactions, fetchDriverOrders, fetchPartnerVehicles } from "./services/services";
import { useParams } from "react-router-dom";
import CustomTable from "../../components/CustomTable/CustomTable";
import ViewModal from "./ViewModal/ViewModal";
import ReasonModal from "../../components/ReasonModal/ReasonModal";
import PartnerProfileSidebar from "./components/PartnerProfileSidebar/PartnerProfileSidebar";
import TaxInfoCard from "./components/TaxInfoCard/TaxInfoCard";
import BankInfoCard from "./components/BankInfoCard/BankInfoCard";
import VehicleViewModal from "./ViewModal/VehicleViewModel";
// import TransactionsHistory from "views/Customers/components/TransactionsHistory";
import OrderDrawer from "../../views/Order/components/OrderDrawer";
import DriverReminderModal from "views/Order/components/DriverReminderModal";
import StatusModal from "views/Order/components/StatusModal";

function PartnerDetails() {
  // GET ID FROM URL
  const { id } = useParams();
  const navigate = useNavigate();
  const [partnerInfo, setPartnerInfo] = useState(null);
  const [taxInfo, setTaxInfo] = useState(null);
  const [bankInfo, setBankInfo] = useState(null);
  const [walletInfo, setwalletInfo] = useState(null);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [reasonModalOpen, setReasonModalOpen] = useState(false);
  const [actionType, setActionType] = useState(""); // "rejected" | "request_info"
  const [selectedId, setSelectedId] = useState(null);
  const [addOpen, setAddOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [walletTransactionsHistory, setWalletTransactionsHistory] = useState(null);
  const [types, setTypes] = useState([]);
  const [transactionType, setTransactionType] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [description, setDescription] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [currentPageForTransaction, setCurrentPageForTransaction] = useState(1);
  const [totalPagesForTransaction, setTotalPagesForTransaction] = useState(1);
  // const [status, setStatus] = useState("");
  const [driverVehicles, setDriverVehicles] = useState([]);
  const [vehicleModalOpen, setVehicleModalOpen] = useState(false);
  const [driverOrders, setDriverOrders] = useState([]);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [driverReminderModalOpen, setDriverReminderModalOpen] = useState(false);
  const [driverReminderForm, setDriverReminderForm] = useState({ title: "", message: "" });
  const [statusForm, setStatusForm] = useState({ status_id: "", description: "" });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [orderStatuses, setOrderStatuses] = useState([]);

  const [currentPageForVehicle, setCurrentPageForVehicle] = useState(1);
  const [searchValueForVehicle, setSearchValueForVehicle] = useState("");
  const [totalPagesForVehicle, setPageForVehicle] = useState(1);

  const [currentPageForOrder, setCurrentPageForOrder] = useState(1);
  const [searchValueForOrder, setSearchValueForOrder] = useState("");
  const [totalPagesForOrder, setTotalPagesForOrder] = useState(1);



  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));




  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const formatCurrency = (value) => {
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return "$0.00";
    return `$${numericValue.toFixed(2)}`;
  };

  const formatDate = (value) =>
    value
      ? new Date(value).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
      : null;

  const getTransactionChipStyles = (type) => {
    if (type === "Credit") {
      return { color: "#2e7d32", bgcolor: "rgba(46,125,50,0.15)" };
    }
    if (type === "Debit") {
      return { color: "#d32f2f", bgcolor: "rgba(211,47,47,0.15)" };
    }
    return { color: "#424242", bgcolor: "rgba(66,66,66,0.15)" };
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  /* ================= Whole DATA ================= */
  const loadPartners = async () => {
    setLoading(true);
    try {

      const res = await fetchPartnerById(id);
      // console.log(res?.data)


      if (res.success) {
        setPartnerInfo(res?.data);
        setPartner(res?.data?.businesses);
        setTaxInfo(res?.data?.user_tax);
        setBankInfo(res?.data?.user_bank);
        setwalletInfo(res?.data?.wallet);
        // setCurrentPage(res?.data.current_page);
        // setTotalPages(res?.data.total_pages);
      }
    } catch {
      showSnackbar("Failed to load data", "error");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { key: "name", label: "Business Name" },
    { key: "address", label: "Address" },
    { key: "business_license_number", label: "License Number" },
    { key: "status", label: "Status" },
    // {
    //   key: "createdAt",
    //   label: "Created At",
    //   render: (value) => new Date(value).toLocaleDateString(),
    // },
  ];

  const handleViewDetails = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };
  const handleViewDetailsVehicle = (item) => {
    setSelectedItem(item);
    setVehicleModalOpen(true);
  };

  const handleAction = (item) => {
    console.log("Action clicked for:", item);
  };
  const modalActions = [
    { label: "approved", color: "success", onClick: (data) => console.log("approved", data) },
    { label: "rejected", color: "error", onClick: (data) => console.log("rejected", data) },
    { label: "request_info", color: "warning", onClick: (data) => console.log("request_info", data) },
  ];

  const handleTaxAction = async (id, action, reason = null) => {
    try {
      setLoading(true);
      let payload = {}
      if (activeTab === 2) {
        payload = {
          id: id,
          status: action,
          reason: reason
        }
      } else if (activeTab === 3) {
        payload = {
          id: id,
          status: action,
          reason: reason
        }
      }
      else {
        payload = {
          id: id,
          status: action,
          reason_for_rejection: reason
        }
      }

      let res;

      if (activeTab === 2) {
        res = await apiRequest.put(
          "/v1/admin/driver/tax/status",
          payload
        );
      } else if (activeTab === 3) {
        res = await apiRequest.put(
          "/v1/admin/driver/bank/status",
          payload
        );
      }
      else {
        res = await apiRequest.put(
          "/v1/admin/driver/status",
          payload
        );
      }

      if (res?.success) {
        showSnackbar(`${action} successfully`, "success");
        loadPartners();
        setReasonModalOpen(false);
      } else {
        showSnackbar(res?.message || "Action failed", "error");
      }
    } catch {
      showSnackbar("Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  // =============Wallet===========//
  const walletColumns = [
    { key: "type", label: "Type" },
    { key: "amount", label: "Amount" },
    { key: "description", label: "Description" },
    {
      key: "createdAt",
      label: "Created At",
      render: (value) => new Date(value).toLocaleDateString(),
    },
  ];

  const loadWalletTypes = async () => {
    try {
      setLoading(true);
      const res = await fetchPartnerWalletTypes();
      // console.log(res)
      if (res?.success) {
        setTypes(res?.data);
      }
    } catch (error) {
      console.error("Error fetching partner wallet types:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchWalletDetails = async () => {
    try {
      setLoading(true);
      const res = await fetchPartnerWallet(id);
      // console.log("wallet", res)
      if (res?.success) {
        setWalletTransactionsHistory(res?.data);

      }
    } catch (error) {
      console.error("Error fetching partner wallet:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchWalletTransactions = async () => {
    if (!walletInfo?.id) return;
    try {
      setLoading(true);
      const params = { page: currentPageForTransaction, searchValue };
      const res = await fetchPartnerWalletTransactions(walletInfo?.id, params);
      // console.log("transection", res)
      if (res?.success) {
        setTransactions(res?.data?.items);
        const pagination = res?.data?.pagination;
        setCurrentPageForTransaction(pagination.current_page);
        setTotalPagesForTransaction(pagination.total_pages);
      }
    } catch (error) {
      console.error("Error fetching partner wallet transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddConfirm = async () => {
    const value = parseFloat(amount);
    if (Number.isNaN(value) || value <= 0) {
      return;
    }

    // setWalletBalance((prev) => prev + value);
    const payload = {
      user_id: id,
      balance: value,
      type: transactionType,
      description: description
    };
    await createOrUpdateWallet(payload);
    showSnackbar("Amount added to wallet.", "success");
    setAddOpen(false);
    setAmount("");
    fetchWalletDetails();
    setTransactionType("");
    setDescription("");
    fetchWalletTransactions();
  };

  // ======= driver vehicle =====//
  const fetchDriverVehicles = async () => {
    try {
      setLoading(true);

      const params = {
        page: currentPageForVehicle, // ✅ correct page
        searchValue: searchValueForVehicle, // ✅ correct search
        // status,
      };

      const driverVehicles = await fetchPartnerVehicles(id, params);

      if (driverVehicles?.success) {
        setDriverVehicles(driverVehicles?.data?.items || []);

        const pagination = driverVehicles?.data?.pagination;
        setCurrentPageForVehicle(pagination?.current_page || 1);
        setPageForVehicle(pagination?.total_pages || 1);
      }
    } catch (error) {
      console.error("Error fetching partner vehicles:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchDriverVehicles();
  }, [currentPageForVehicle, searchValueForVehicle]);

  // ===== Use Effect =====//
  useEffect(() => {
    if (walletInfo?.id) {
      fetchWalletTransactions();
    }
  }, [walletInfo?.id, currentPageForTransaction, searchValue]);
  useEffect(() => {
    loadPartners();
    fetchWalletDetails();
    loadWalletTypes();
  }, []);

  // ===== driver vehicle columns =====
  const driverVehicleColumns = [
    { key: "number_plate", label: "Number Plate" },
    { key: "vehicle_make", label: "Vehicle Make" },
    { key: "vehicle_model", label: "Vehicle Model" },
    { key: "vehicle_color", label: "Vehicle Color" },
    { key: "vehicle_year", label: "Vehicle Year" },
    { key: "status", label: "Status" },
    { key: "registration_number", label: "Registration Number" },

  ];

  // ===== order columns ======= //

  const fetchOrders = async () => {
    try {
      const params = {
        page: currentPageForOrder,
        searchValue: searchValueForOrder,
        // status,
      };

      const driverOrderss = await fetchDriverOrders(id, params);

      if (driverOrderss.success) {
        setDriverOrders(driverOrderss.data.items);

        const pagination = driverOrderss.data.pagination;
        setCurrentPageForOrder(pagination?.current_page || 1);
        setTotalPagesForOrder(pagination?.total_pages || 1);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [currentPageForOrder, searchValueForOrder]);

  const driverOrderColumns = [
    { key: "order_ref", label: "Order Ref" },
    {
      key: "user_id",
      label: "Customer",
      render: (value, row) => row.user?.full_name ?? row.user_id
    },
    {
      key: "driver_id",
      label: "Partner",
      render: (value, row) => {
        const driverName = row.driver?.full_name || row.driver_id;
        const businessName = row.business?.name;

        return businessName
          ? `${driverName} (${businessName})`
          : driverName;
      }
    },
    {
      key: "category_id",
      label: "Category",
      render: (value, row) => row.category?.name_en ?? row.category_id
    },
    {
      key: "service_type_id",
      label: "Service Type",
      render: (value, row) => row.service_type?.name_en ?? row.service_type_id
    },
    {
      key: "current_status_id",
      label: "Current Status",
      render: (value, row) => row.current_order_status?.name ?? row.current_status_id
    },
  ];

  const handleDetailClick = (order) => {
    fetchSingleOrder(order.id);
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedOrder(null);
  };
  const fetchSingleOrder = async (id) => {
    try {
      const response = await apiRequest.get(`${endPoints.GET_SINGLE_ORDER}/${id}`, {}, {});
      if (response.success) {
        setSelectedOrder(response.data);
      }
    } catch (error) {
      console.error("Error fetching order statuses:", error);
    }
  };


  const handleDriverReminderChange = (e) => {
    const { name, value } = e.target;
    setDriverReminderForm(prev => ({ ...prev, [name]: value }));
  };

  const handleDriverReminderModal = () => {
    setDriverReminderModalOpen(true);
    setDriverReminderForm({ title: "", message: "" });
  };

  const handleStatusModal = () => {
    setStatusModalOpen(true);
    setStatusForm({ title: "", message: "" });
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setStatusForm(prev => ({ ...prev, [name]: value }));
  };



  const handleSendDriverReminder = async () => {
    if (!driverReminderForm.title || !driverReminderForm.message) {
      setError("Title and message are required.");
      return;
    }
    const formData = {
      order_id: selectedOrder?.id,
      title: driverReminderForm.title,
      description: driverReminderForm.message
    };

    const response = await apiRequest.post(endPoints.SEND_DRIVER_REMINDER, formData, {});
    console.log(response)
    if (!response.success) {
      setError("Failed to send driver reminder. Please try again.");
      return;
    }
    setDriverReminderModalOpen(false);
    setSuccess("Driver reminder sent successfully.");
  };

  const handleSaveStatus = async () => {
    if (!statusForm.status_id) {
      setError("Please select a status.");
      return;
    }
    const formData = {
      status_id: statusForm.status_id,
      order_id: selectedOrder?.id,
      description: statusForm.description
    };
    const response = await apiRequest.post(endPoints.CHANGE_ORDER_STATUS, formData, {});
    if (response.success) {
      // fetchOrders(currentPage, selectedStatus);
      fetchSingleOrder(selectedOrder?.id);
      setStatusModalOpen(false);
      setSuccess("Order status updated successfully.");
      fetchOrders();
    } else {
      setError("Failed to update order status. Please try again.");
    }
  };

  const fetchOrderStatuses = async () => {
    try {
      const response = await apiRequest.get(endPoints.GET_ORDER_STATUSES, { limit: 0 }, {});
      if (response.success) {
        setOrderStatuses(response.data.items);
      }
    } catch (error) {
      console.error("Error fetching order statuses:", error);
    }
  };

  useEffect(() => {
    fetchOrderStatuses();
  }, []);
  //==== configration  tabs =====//

  const tabConfig = [
    {
      label: "Profile Info",
      header: "Profile Information",
      icon: <AccountCircleIcon fontSize="small" />,
    },
    {
      label: "Business Details",
      header: "Business Details",
      icon: <BusinessCenterIcon fontSize="small" />,
    },
    {
      label: "Tax Info",
      header: "Tax Information",
      icon: <ReceiptLongIcon fontSize="small" />,
    },
    {
      label: "Bank Info",
      header: "Bank Information",
      icon: <AccountBalanceIcon fontSize="small" />,
    },
    {
      label: "Transactions Info",
      header: "Wallet Activity",
      icon: <AccountBalanceWalletIcon fontSize="small" />,
    },
    {
      label: "Orders Info",
      header: "Order Information",
      icon: <ListAltIcon fontSize="small" />,
    },
    {
      label: "Vehicle Info",
      header: "Vehicle Information",
      icon: <DirectionsCarIcon fontSize="small" />,
    },
  ];

  const tabHeaders = tabConfig.map((tab) => tab.header);

  const lastTransaction = walletTransactionsHistory?.transactions?.[0];
  const lastTransactionType = lastTransaction?.type;
  const lastTransactionAmount = lastTransaction?.amount;
  const lastTransactionDate = lastTransaction?.createdAt ?? lastTransaction?.created_at;

  const summaryStats = [
    {
      label: "Businesses",
      value: partner?.length ?? 0,
    },
    {
      label: "Wallet Balance",
      value: formatCurrency(walletTransactionsHistory?.balance),
      walletDetails: {
        lastTransactionType,
        lastTransactionAmount,
        lastTransactionDate,
      },
    },
    {
      label: "Orders",
      value: partnerInfo?.total_orders ?? 0,
    },
    {
      label: "Vehicles",
      value: driverVehicles?.length ?? 0,
    },
  ];

  const renderActiveTabContent = () => {
    // console.log(activeTab)
    switch (activeTab) {
      case 0:
        return (
          <PartnerProfileSidebar
            partnerInfo={partnerInfo}
            // walletTransactionsHistory={walletTransactionsHistory}
            loading={loading}
            handleTaxAction={handleTaxAction}
            setSelectedId={setSelectedId}
            setActionType={setActionType}
            setReasonModalOpen={setReasonModalOpen}
          />
        );
      case 1:
        return (
          <CustomTable
            data={partner || []}
            columns={columns}
            onViewDetails={handleViewDetails}
            onActionClick={handleAction}
          />
        );
      case 2:
        return (
          <TaxInfoCard
            taxInfo={taxInfo}
            loading={loading}
            handleTaxAction={handleTaxAction}
            setSelectedId={setSelectedId}
            setActionType={setActionType}
            setReasonModalOpen={setReasonModalOpen}
            setPreviewImage={setPreviewImage}
            setPreviewOpen={setPreviewOpen}
          />
        );
      case 3:
        return (
          <BankInfoCard
            bankInfo={bankInfo}
            loading={loading}
            handleTaxAction={handleTaxAction}
            setSelectedId={setSelectedId}
            setActionType={setActionType}
            setReasonModalOpen={setReasonModalOpen}
            setPreviewImage={setPreviewImage}
            setPreviewOpen={setPreviewOpen}
          />
        );
      case 4:
        return (
          <>
            <MDBox
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
              mb={3}
            >
              <TextField
                label="Search"
                variant="outlined"
                placeholder="Search transactions"
                value={searchValue}
                onChange={(e) => {
                  setCurrentPageForTransaction(1);
                  setSearchValue(e.target.value);
                }}
                sx={{ minWidth: { xs: "100%", sm: 240 } }}
              />
              {/* setSearchValueForOrder */}

              <Button
                variant="contained"
                sx={{
                  bgcolor: "#2db84bff",
                  color: "#fff",
                  px: 3,
                }}
                onClick={() => setAddOpen(true)}
              >
                Credit Or Debit
              </Button>
            </MDBox>

            <CustomTable data={transactions || []} columns={walletColumns} />
            <PaginationControls
              currentPage={currentPageForTransaction}
              totalPages={totalPagesForTransaction}
              onPageChange={setCurrentPageForTransaction}
            />
          </>
        );
      case 5:
        return (
          <>
            <MDBox
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
              mb={3}
            >
              <TextField
                label="Search"
                variant="outlined"
                placeholder="Search transactions"
                value={searchValueForOrder}
                onChange={(e) => {
                  setCurrentPageForOrder(1);
                  setSearchValueForOrder(e.target.value);
                }}
                sx={{ minWidth: { xs: "100%", sm: 240 } }}
              />
            </MDBox>
            <CustomTable
              data={driverOrders || []}
              columns={driverOrderColumns}
              onViewDetails={handleDetailClick}
            />
            <PaginationControls
              currentPage={currentPageForOrder}
              totalPages={totalPagesForOrder}
              onPageChange={setCurrentPageForOrder}
            />

          </>
        );
      case 6:
        return (
          <>
            <MDBox
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
              mb={3}
            >
              <TextField
                label="Search"
                variant="outlined"
                placeholder="Search vehicles"
                value={searchValueForVehicle}
                onChange={(e) => {
                  setCurrentPageForVehicle(1);
                  setSearchValueForVehicle(e.target.value);
                }}
                sx={{ minWidth: { xs: "100%", sm: 240 } }}
              />
            </MDBox>
            <CustomTable
              data={driverVehicles || []}
              columns={driverVehicleColumns}
              onViewDetails={handleViewDetailsVehicle}
            />
            <PaginationControls
              currentPage={currentPageForVehicle}
              totalPages={totalPagesForVehicle}
              onPageChange={setCurrentPageForVehicle}
            />

          </>
        );
      default:
        return null;
    }
  };

  // console.log("activeTab", activeTab);
  const getDriverStatusColor = (status) => {
    const normalizedStatus = status?.toLowerCase();
    if (normalizedStatus === "approved") return "success";
    if (normalizedStatus === "rejected") return "error";
    return "warning";
  };
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <MDTypography variant="h4">Partner Details</MDTypography>
          <CancelButton
            onClick={() => navigate(-1)}
            sx={{ color: "#000 !important", border: "1px solid #45ce23ff !important" }}
          >
            Back
          </CancelButton>
        </MDBox>
        <Grid container spacing={3} mb={1}>
          <Grid item xs={12}>
            <Card
              sx={{
                p: { xs: 3, md: 4 },
                background: "linear-gradient(135deg, #daf5d3 0%, #b7f0c1 100%)",
                color: "#1b4332",
                borderRadius: 3,
              }}
            >
              <MDTypography variant="h5" fontWeight={600}>
                Partner Overview
              </MDTypography>
              <MDTypography variant="body2" mt={1} opacity={0.8}>
                Snapshot of orders, wallet, and fleet
              </MDTypography>

              <Grid container spacing={2} mt={1}>
                {summaryStats.map((stat) => (
                  <Grid item xs={6} md={3} key={stat.label}>
                    <MDBox
                      sx={{
                        backdropFilter: "blur(6px)",
                        bgcolor: "rgba(255,255,255,0.65)",
                        borderRadius: 2,
                        px: 2,
                        py: 1.5,
                        mt: 2,
                        ...(stat.walletDetails && { minHeight: 90 }),
                      }}
                    >
                      {stat.walletDetails ? (
                        <MDBox
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                          }}
                        >
                          <MDBox>
                            <MDTypography variant="button" color="#2e7d32">
                              {stat.label}
                            </MDTypography>
                            <MDTypography variant="h6" color="#1b5e20" mt={0.5}>
                              {stat.value}
                            </MDTypography>
                          </MDBox>

                          <MDBox textAlign="right">
                            <MDTypography variant="button" color="#2e7d32">
                              Last transaction
                            </MDTypography>
                            <MDBox
                              display="flex"
                              justifyContent="flex-end"
                              alignItems="center"
                              gap={1}
                              mt={0.5}
                              flexWrap="wrap"
                            >
                              <MDTypography
                                variant="h6"
                                fontWeight={600}
                                color="#1b4332"
                              >
                                {formatCurrency(
                                  stat.walletDetails.lastTransactionAmount
                                )}
                              </MDTypography>
                              <Chip
                                size="small"
                                label={
                                  stat.walletDetails.lastTransactionType ||
                                  "No activity"
                                }
                                sx={{
                                  fontWeight: 600,
                                  textTransform: "capitalize",
                                  ...getTransactionChipStyles(
                                    stat.walletDetails.lastTransactionType
                                  ),
                                }}
                              />
                              <MDTypography
                                variant="caption"
                                color="text.secondary"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {stat.walletDetails.lastTransactionDate
                                  ? formatDate(
                                    stat.walletDetails.lastTransactionDate
                                  )
                                  : ""}
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      ) : (
                        <>
                          <MDTypography variant="button" color="#2e7d32">
                            {stat.label}
                          </MDTypography>
                          <MDTypography variant="h6" color="#1b5e20" mt={0.5}>
                            {stat.value}
                          </MDTypography>
                        </>
                      )}
                    </MDBox>
                  </Grid>
                ))}

              </Grid>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <Card sx={{ p: 2, height: "100%" }}>
              <Tabs
                orientation="vertical"
                value={activeTab}
                onChange={(e, newValue) => setActiveTab(newValue)}
                sx={{
                  borderRight: 1,
                  borderColor: "divider",
                  "& .MuiTab-root": {
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    textAlign: "left",
                    gap: 1,
                    fontWeight: 500,
                  },
                }}
              >
                {tabConfig.map((tab) => (
                  <Tab
                    key={tab.label}
                    label={tab.label}
                    icon={tab.icon}
                    iconPosition="start"
                  />
                ))}
              </Tabs>
            </Card>
          </Grid>

          <Grid item xs={12} md={9}>
            <Card sx={{ p: { xs: 2, md: 3 }, minHeight: 400 }}>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", md: "center" }}
                flexDirection={{ xs: "column", md: "row" }}
                gap={1}
                mb={2}
              >
                <MDTypography
                  variant="h6"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5, // 👈 controls spacing
                  }}
                >
                  {tabHeaders[activeTab]}

                  {activeTab === 0 ? (
                    <Chip
                      label={partnerInfo?.driver?.status}
                      color={getDriverStatusColor(partnerInfo?.driver?.status)}
                      size="small"
                      sx={{ textTransform: "capitalize" }}
                    />
                  ) : activeTab === 2 ? (
                    <Chip
                      label={taxInfo?.status}
                      color={getDriverStatusColor(taxInfo?.status)}
                      size="small"
                      sx={{ textTransform: "capitalize" }}
                    />
                  ) : activeTab === 3 ? (
                    <Chip
                      label={bankInfo?.status}
                      color={getDriverStatusColor(bankInfo?.status)}
                      size="small"
                      sx={{ textTransform: "capitalize" }}
                    />
                  ) : null}
                </MDTypography>

                {/* <Chip
                  label={`Active Tab ${activeTab + 1}`}
                  color="primary"
                  variant="outlined"
                /> */}
              </MDBox>

              {renderActiveTabContent()}
            </Card>
          </Grid>
        </Grid>
        {/* Vehicle Modal */}
        <VehicleViewModal
          open={vehicleModalOpen}
          onClose={() => setVehicleModalOpen(false)}
          data={selectedItem}
          actions={modalActions}
          onRefresh={loadPartners}
        />
        {/* simple modal */}
        <ViewModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          data={selectedItem}
          actions={modalActions}
          onRefresh={loadPartners}
        />
        {/* order modal */}
        <OrderDrawer
          isDrawerOpen={isDrawerOpen}
          isMobile={isMobile}
          selectedOrder={selectedOrder}
          handleCloseDrawer={handleCloseDrawer}
          handleStatusModal={handleStatusModal}
          handleDriverReminderModal={handleDriverReminderModal}
        />


        <DriverReminderModal
          driverReminderModalOpen={driverReminderModalOpen}
          driverReminderForm={driverReminderForm}
          handleDriverReminderChange={handleDriverReminderChange}
          handleSendDriverReminder={handleSendDriverReminder}
          setDriverReminderModalOpen={setDriverReminderModalOpen}
        />

        <StatusModal
          statusModalOpen={statusModalOpen}
          statusForm={statusForm}
          orderStatuses={orderStatuses}
          handleStatusChange={handleStatusChange}
          handleSaveStatus={handleSaveStatus}
          setStatusModalOpen={setStatusModalOpen}
        />
        <ImagePreview
          open={previewOpen}
          imageSrc={previewImage}
          onClose={() => setPreviewOpen(false)}
        />

        {/* Reason Modal */}
        <ReasonModal
          open={reasonModalOpen}
          title={actionType === "rejected" ? "Reject Info" : "Request More Information"}
          actionColor={actionType === "rejected" ? "error" : "warning"}
          onClose={() => setReasonModalOpen(false)}
          onSubmit={(reason) => handleTaxAction(selectedId, actionType, reason)}
        />


        {/* GLOBAL LOADER */}
        <PageLoader open={loading} />

        {/* SNACKBAR */}
        <AppSnackbar
          open={snackbar.open}
          message={snackbar.message}
          severity={snackbar.severity}
          onClose={handleCloseSnackbar}
        />
        <Snackbar
          open={!!error || !!success}
          autoHideDuration={3000}
          onClose={() => { setError(null); setSuccess(null); }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert
            onClose={() => { setError(null); setSuccess(null); }}
            severity={error ? "error" : "success"}
            sx={{ width: '100%' }}
          >
            {error || success}
          </Alert>
        </Snackbar>
      </DashboardLayout >
      {/* amount dailog box */}
      < Dialog open={addOpen} onClose={() => !loading && setAddOpen(false)
      } maxWidth="xs" fullWidth >
        <DialogTitle>Add Amount</DialogTitle>

        <DialogContent>
          <Stack spacing={2}>
            {/* Transaction Type */}
            <Autocomplete
              options={types.filter(type => type === "Credit" || type === "Debit")}
              value={transactionType || null}
              onChange={(event, newValue) => setTransactionType(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Transaction Type"
                  required
                  disabled={loading}
                />
              )}
            />


            {/* Amount */}
            <TextField
              label="Amount"
              type="number"
              fullWidth
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              inputProps={{ min: 0 }}
              disabled={loading}
            />
            {/* Description */}
            <TextField
              label="Description"
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              multiline
              rows={4}
              disabled={loading}
            />
          </Stack>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => {
              setAddOpen(false);
              setAmount("");
              setTransactionType("");
            }}
            disabled={loading}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            sx={{
              bgcolor: "#2db84bff",
              color: "#fff",
            }}
            onClick={handleAddConfirm}
            disabled={!amount || Number(amount) <= 0 || !transactionType || loading}
          >
            {loading ? "Processing..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog >
    </>
  );
}

export default PartnerDetails;
